import { render, staticRenderFns } from "./vipManage.vue?vue&type=template&id=520e1486&scoped=true"
import script from "./vipManage.vue?vue&type=script&lang=js"
export * from "./vipManage.vue?vue&type=script&lang=js"
import style0 from "./vipManage.vue?vue&type=style&index=0&id=520e1486&lang=scss"
import style1 from "./vipManage.vue?vue&type=style&index=1&id=520e1486&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e1486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520e1486')) {
      api.createRecord('520e1486', component.options)
    } else {
      api.reload('520e1486', component.options)
    }
    module.hot.accept("./vipManage.vue?vue&type=template&id=520e1486&scoped=true", function () {
      api.rerender('520e1486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/vipManage/vipManage.vue"
export default component.exports